import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/correios',
  title: 'Correios',
  endpoint: '/app/expedition/order',
  breadcrumbs: [],
}
